import { IQuizResultsEvolutionByDateRange } from '@sdk/contracts';
import { useQuery } from '@tanstack/react-query';

import { useQuizStatsFilters } from '@/hooks';
import { sdk } from '@/services';
import { getLocalTimeZone, showTimeZone, transformQuizResponseForGraph } from '@/utils';

const QuizResultService = sdk.getService('QuizResultService');

export const useMyQuizzesEvolutionByDateRank = () => {
  const { dateFilter, dateInterval } = useQuizStatsFilters();
  const timezone = showTimeZone(getLocalTimeZone());
  const queryKey = ['quiz-results', 'evolution-by-date-rank', dateFilter, dateInterval, timezone];
  const { data, isLoading } = useQuery<IQuizResultsEvolutionByDateRange[]>({
    queryKey,
    queryFn: () => QuizResultService.findEvolutionByDateRank(dateFilter, dateInterval, timezone)
  });
  const dataQuizEvolution = transformQuizResponseForGraph(
    data as IQuizResultsEvolutionByDateRange[],
    dateInterval,
    timezone
  );
  return {
    isLoading,
    data: dataQuizEvolution
  };
};
